import script from "./LeaderMyCompetenceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderMyCompetenceForm.vue?vue&type=script&setup=true&lang=js"

import "./LeaderMyCompetenceForm.vue?vue&type=style&index=0&id=008756fc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008756fc"]])

export default __exports__